import type { Entity } from '@models/Entity'

import { apiClient } from '../../../gateways/api'
import type { Contactpersoon } from '../types/Contactpersoon'

export { fetchContactpersonenForEntity, initialState }

async function fetchContactpersonenForEntity({
  id,
  type,
}: Entity): Promise<Contactpersoon[]> {
  const { data } = await apiClient({
    url: `/rest/${type}/${id}/contactpersoon`,
    method: 'GET',
  })

  return data
}

const initialState: { data: Contactpersoon[] } = {
  data: [],
}
